<script setup lang="ts">
import SectionTitle from '@/components/atoms/SectionTitle.vue'
import FadeTransition from '@/components/transitions/FadeTransition.vue'
import LineMessageSendingQuota from '@/components/organisms/LineMessageSendingQuota/LineMessageSendingQuota.vue'
import { type DashboardPageLineMessageSendingQuotaSectionFragment } from './DashboardPageLineMessageSendingQuotaSection.generated.ts'

const props = defineProps<{
  lineMessageSendingQuota: DashboardPageLineMessageSendingQuotaSectionFragment
}>()
</script>

<template>
  <section :class="$style.section">
    <header :class="[$style.section__header, $style.header]">
      <SectionTitle :class="$style.header__title"
        >LINEメッセージ配信
      </SectionTitle>
    </header>
    <section :class="[$style.section__contents, $style.contents]">
      <FadeTransition>
        <LineMessageSendingQuota
          :fragment="props.lineMessageSendingQuota"
          :class="$style.contents__list"
        />
      </FadeTransition>
    </section>
  </section>
</template>

<style lang="scss" module>
.header {
  display: flex;

  &__title {
    flex-grow: 1;
  }
}

.section {
  &__title {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }

  &__contents {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}

.contents {
  display: flex;
  overflow: hidden;
  min-height: 88px;
  align-items: center;
  justify-content: center;
  background-color: $color-surface-primary;
  border-radius: $border-radius-v2-rounder;
  box-shadow: $shadow-20;

  &__list {
    width: 100%;
    padding: 32px;
  }
}
</style>
